@if (loading && !showFilters && !isCurrentImport) {
  <div class="gt-filter-container gt-filter-loading-bar">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Loading filters...</span>
  </div>
}

@if (showFilters || hasScreenActionButtons() || (!isCurrentImport && !isCeScreen && !loading)) {
  <div class="gt-filter-container" [class.gt-filter-cascading]="cascading">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh" (click)="refresh()" title="Refresh Data"></i>
    </div>
    @for (filter of filters; track filter) {
      @if (filter.ui_type === 'df-select-filter-by' && filter.values?.length) {
        <div class="gt-filter-item"
          >
          <div class="input-group filter-by-group">
            <span class="input-group-addon">Filter By:</span>
            <select
              class="gt-filter-select"
              [title]="filter.label"
              [value]="getSelectedIndex(filter)"
              [disabled]="cascading"
              (change)="onFilterChangeByIndex(filter, $event)">
              @for (opt of filter.values; track opt; let i = $index) {
                <option
                  [value]="i"
                  [selected]="i === getSelectedIndex(filter)">
                  {{ getDisplayValue(filter, opt) }}
                </option>
              }
            </select>
            @if (isFilterLoading(filter)) {
              <i class="fa fa-refresh fa-spin gt-filter-inline-refresh" title="Refreshing filter"></i>
            }
          </div>
        </div>
      }
      @if (isMeDropdown(filter) && !isHiddenByFilterBy(filter)) {
        <div class="gt-filter-item"
          >
          <gtw-df-me-dropdown
            [meData]="filter.values"
            [buttonLabel]="filter.label || 'ME(s)'"
            [preSelectedKeys]="getMeSelectedKeys(filter)"
            (selectedMes)="onMeSelectionChanged(filter, $event)">
          </gtw-df-me-dropdown>
          @if (isFilterLoading(filter)) {
            <i class="fa fa-refresh fa-spin gt-filter-inline-refresh" title="Refreshing filter"></i>
          }
        </div>
      }
      @if (isMultiSelectType(filter) && !isMeDropdown(filter) && !isHiddenByFilterBy(filter)) {
        <div class="gt-filter-item"
          >
          <div class="gt-multiselect-wrapper" #multiWrap>
            @if (screenKey !== 10802) {
              <div class="gt-multiselect-btn" (click)="toggleMultiMenu(filter); $event.stopPropagation()">
                <span>{{ filter.label || 'ME(s)' }}</span>
                <i class="fa fa-caret-down"></i>
                @if (getMultiCount(filter) > 0) {
                  <span class="badge">{{ getMultiCount(filter) }}</span>
                }
              </div>
            }
            @if (screenKey === 10802) {
              <div class="gt-multiselect-btn" (click)="toggleMultiMenu(filter); $event.stopPropagation()">
                @if (getMultiCount(filter) > 0) {
                  <span>{{ getMultiCount(filter) }} Checked</span>
                }
                @if (getMultiCount(filter) === 0) {
                  <span>{{ filter.label || 'ME(s)' }}</span>
                }
                <i class="fa fa-caret-down"></i>
              </div>
            }
            @if (filter._menuOpen) {
              <div class="gt-multiselect-dropdown">
                @if (filter.values?.length) {
                  <div class="gt-multi-actions">
                    @if (!isSingleSelectDropdown(filter)) {
                      <span (click)="multiSelectAll(filter); $event.stopPropagation()">Select All</span>
                    }
                    <span (click)="multiUnselectAll(filter); $event.stopPropagation()">{{ isSingleSelectDropdown(filter) ? 'Unselect' : 'Unselect All' }}</span>
                  </div>
                }
                @if (filter.values?.length) {
                  <input type="text" class="gt-multi-search" placeholder="Search..."
                    [(ngModel)]="filter._searchText" (ngModelChange)="onMultiSearch(filter)"
                    (click)="$event.stopPropagation()">
                }
                @if (filter.values?.length) {
                  <ul class="gt-multi-list">
                    @for (opt of getFilteredMultiValues(filter); track opt) {
                      <li
                        (click)="toggleMultiItem(filter, opt); $event.stopPropagation()">
                        @if (isMultiChecked(filter, opt)) {
                          <i class="fa fa-check"></i>
                        }
                        <span>{{ opt.LABEL || opt.NAME || opt.name || opt.label || opt.VALUE }}</span>
                      </li>
                    }
                  </ul>
                }
                @if (!filter.values?.length && isFilterLoading(filter)) {
                  <div class="gt-multi-empty">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Loading...</span>
                  </div>
                }
                @if (!filter.values?.length && !isFilterLoading(filter)) {
                  <div class="gt-multi-empty">
                    <i>No items available</i>
                  </div>
                }
              </div>
            }
          </div>
          @if (isFilterLoading(filter)) {
            <i class="fa fa-refresh fa-spin gt-filter-inline-refresh" title="Refreshing filter"></i>
          }
        </div>
      }
      @if (isSingleSelectType(filter) && filter.values?.length && !isHiddenByFilterBy(filter)) {
        <div class="gt-filter-item"
          >
          <select
            class="gt-filter-select"
            [title]="filter.label"
            [value]="getSelectedIndex(filter)"
            [disabled]="cascading"
            (change)="onFilterChangeByIndex(filter, $event)">
            @for (opt of filter.values; track opt; let i = $index) {
              <option
                [value]="i"
                [selected]="i === getSelectedIndex(filter)">
                {{ getDisplayValue(filter, opt) }}
              </option>
            }
          </select>
          @if (isFilterLoading(filter)) {
            <i class="fa fa-refresh fa-spin gt-filter-inline-refresh" title="Refreshing filter"></i>
          }
        </div>
      }
      @if (isTextFilter(filter) && !isHiddenByFilterBy(filter)) {
        <div class="gt-filter-item"
          >
          <input
            type="text"
            class="gt-filter-text-input form-control"
            [title]="filter.label"
            [placeholder]="filter.label"
            [value]="getTextFilterValue(filter)"
            [disabled]="cascading"
            (input)="onTextFilterChange(filter, $event)">
          </div>
        }
      }
      <div class="gt-filter-item filter-actions">
        <!--
        Filter / Download are suppressed on import screens to mirror legacy.
        AngularJS used two separate filter-bar templates:
        - `grid-filters-tpl.html`  (regular screens) → renders the green
        Filter and Download buttons gated by `filterObjs.filters.length`.
        - `grid-import-tpl.html`   (grid_type=import / import screen_type)
        → renders the filter dropdowns + a "filters don't match" warning
        but deliberately OMITS the Filter and Download buttons. The
        user re-runs the import via the dedicated `Save Data` /
        `Cancel Data Load` toolbar (lines 122-158 of the import
        template), and downloading filtered data isn't a supported
        workflow for import grids — they're write-only intake
        surfaces.
        The migrated component collapsed both templates into a single
        host, so the import-mode suppression has to be re-asserted as an
        `!isCurrentImport` gate alongside the legacy `filters.length` gate.
        `isCurrentImport` is set in `initFilters()` from
        `isImportLikeScreen(activeScreen)` (matches `IMPORT_SCREEN_TYPES`
        OR `data.settings.grid_type === 'import'`) — exact parity with the
        legacy template-selection rule.
        -->
        @if (filters.length && !isCurrentImport) {
          <button class="btn btn-xs btn-success" (click)="refresh()" [disabled]="cascading">Filter</button>
        }
        @if (filters.length && !isCurrentImport) {
          <button class="btn btn-xs btn-success" (click)="downloadExcel()" [disabled]="downloading || cascading">
            Download @if (downloading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      }
      @if (screenKey === 11442) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11442)">Add New Service</button>
      }
      @if (screenKey === 10898) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(10898)">Create New Group</button>
      }
      @if (screenKey === 10895) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(10895)">Create State Entity</button>
      }
      @if (screenKey === 11149) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11149)">Create New Override Entity</button>
      }
      @if (screenKey === 11163) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11163)">Create Scenario Entity</button>
      }
      @if (screenKey === 11165) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11165)">Create Reference Table Entity</button>
      }
      @if (screenKey === 11166) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11166)">Create Configuration Entity</button>
      }
      @if (screenKey === 11167) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11167)">Create Filing Date Entity</button>
      }
      @if (screenKey === 11446) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11446)">Create Refresh Setup Entity</button>
      }
      @if (screenKey === 11451) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11451)">Create Quarter Map Entity</button>
      }
      @if (screenKey === 11462) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11462)">Add New</button>
      }
      @if (screenKey === 11463) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11463)">Add New</button>
      }
      @if (screenKey === 11464) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11464)">Add New</button>
      }
      @if (screenKey === 11465) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11465)">Add New</button>
      }
      @if (screenKey === 11466) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11466)">Add New</button>
      }
      @if (screenKey === 11467) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11467)">Add New</button>
      }
      @if (screenKey === 11476) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11476)">Add New</button>
      }
      @if (screenKey === 11477) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11477)">Add New</button>
      }
      @if (screenKey === 11673) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11673)">Add New</button>
      }
      @if (screenKey === 11468) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11468)">Create Threshold Management</button>
      }
      @if (screenKey === 11555) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11555)">Create 851 Config Entity</button>
      }
      @if (screenKey === 11554) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11554)">Create LE Override</button>
      }
      @if (screenKey === 11616) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11616)">Create Default Sourcing Override</button>
      }
      @if (screenKey === 11618) {
        <button class="btn btn-xs btn-success" (click)="launchCustomModalForSpecificScreen(11618)">Extract Elements from XML</button>
      }
    </div>
    @if (!isCurrentImport) {
      <div class="gt-filter-item gt-doc-btn">
        <div class="btn btn-xs" (click)="openDocument()" title="Screen Documents">
          <i class="fa fa-file"></i>
        </div>
      </div>
    }
  </div>
}
